import { InstructionProps } from "../types";
import styles from "../style.module.css";
import CopyText from "../../../components/copytext";
import ButtonLink from "../../../components/button-link";
import { isTelegramWebApp } from "../../../utils/telegram";
const EXE_HREF = "/setup-Happ.x64.exe";

const InstructionWindows = ({accessData}: InstructionProps) => {

  const handleOpenHappWithConfig = () => {
    const happUrl = `happ://add/${accessData}`;
    if (isTelegramWebApp()) {
      const openedWindow = window.open(happUrl, "_blank");
      if (openedWindow) {
        return;
      }
    }

    window.location.assign(happUrl);
  };

  return (
    <>
      <h1>Настройка на Windows</h1>
      <p>Займет 2 минуты</p>
      <hr className={styles.separator}/>

      <div className={styles.step}>
        <h2>Шаг 1</h2>
        <p>Установите приложение Happ, кликнув кнопку ниже. В нем вы будете включать и выключать VPN.</p>
        <ButtonLink
          label={"Скачать файл"}
          href={EXE_HREF}
          onClick={() => {
            if (isTelegramWebApp()) {
              // @ts-ignore
              const tg = window.Telegram?.WebApp;
              if (tg?.openLink) {
                tg.openLink(new URL(EXE_HREF, window.location.origin).toString());
                return;
              }
            }
            window.location.href = EXE_HREF;
          }}
        ></ButtonLink>
         <div style={{backgroundColor: "var(--transperent-white-70)", padding: "16px", borderRadius: "16px", marginTop: "16px", border: "1px solid var(--transperent-white-100)"}}>
          <h3 style={{ marginTop: "0", display: "flex", alignItems: "center", gap: "4px"}}><img style={{width: "20px", height: "20px"}} src="/images/instruction/android/icon-save.svg" alt="Security" /> Файл безопасен</h3>
          <p>Предоставлен <a href="https://www.happ.su/main/ru" target="_blank" rel="noreferrer">официальным разработчиком</a> и не содержит угроз. Вы можете убедиться в этом самостоятельно, используя <a href="https://www.virustotal.com/gui/home/upload" target="_blank" rel="noreferrer">VirusTotal</a></p>
        </div>
      </div>

   
      <div className={styles.step}>
        <h2>Шаг 2</h2>
        <p>Нажмите кнопку ниже, чтобы добавить подписку. Приложение откроется и подписка добавится автоматически.</p>
        <ButtonLink label={"Добавить подписку"} href="happ://" onClick={handleOpenHappWithConfig}></ButtonLink>
      </div>
      <div className={styles.step}>
        <h2>Или</h2>
        <p>Если добавление подписки по кнопке не работает, добавьте ее вручную.</p>
        <h3>Скопируйте ссылку</h3>
        <CopyText text={accessData}></CopyText>
        <h3 style={{marginTop: "20px"}}>Откройте приложение Happ</h3>
        <p>Нажмите кнопку 🌐 в левой боковой панели. В открывшемся окне вставьте скопированную ранее ссылку и нажмите «Добавить».</p>
        <img className={styles.image} src="/images/instruction/windows/Windows_1.webp" alt="Step 1"/>
      </div>

      <div className={styles.step}>
        <h2>Шаг 3</h2>
        <p>На главном экране приложения появилась подписка Openway. Выберите сервер и нажмите кнопку справа, чтобы включить VPN.</p>
        <div style={{backgroundColor: "var(--transperent-white-70)", padding: "16px", borderRadius: "16px", marginTop: "16px",marginBottom: "16px", border: "1px solid var(--transperent-white-100)"}}>
          <h3 style={{ marginTop: "0", display: "flex", alignItems: "center", gap: "4px"}}><img style={{width: "20px", height: "20px"}} src="/images/instruction/android/icon-save.svg" alt="Security" /> Обход белых списков</h3>
          <p style={{margin: 0}}>Чтобы обходить белые списки, выберите сервер «Обход глушилок»</p>
        </div>
        <img className={styles.image} src="/images/instruction/windows/Windows_2.webp" alt="Step 2"/>
      </div>
     
      
      <div className={styles.step}>
        <h2>Готово</h2>
        <p>Включайте и выключайте VPN, используя это приложение.</p>
        <img className={styles.image} src="/images/instruction/windows/Windows_3.webp" alt="Step 3"/>
      </div>
    </>
  );
};

export default InstructionWindows;